import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

import { Box, Button, Collapse } from "@mui/material";
import React, { useState } from "react";

const ExpandableSection = (props) => {
  const { children, label } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [buttonChevron, setButtonChevron] = useState(<ExpandMore/>);
    const expandSection = () => {
        setIsCollapsed((prev) => !prev);
        if( isCollapsed ) {
            setButtonChevron( <ExpandLess /> );
        }
        else {
            setButtonChevron(<ExpandMore/>);
        }


    }
  return (
      <div className="expandable">
          <Button onClick={expandSection} variant="outlined" endIcon={buttonChevron}>
             {label} 
          </Button>
            <Box sx={{ display: 'flex' }}>
                <Collapse in={!isCollapsed}>{children}</Collapse> 
            </Box>
      </div>
  )
};

export default ExpandableSection;
